import { render, staticRenderFns } from "./VueCodemirror.vue?vue&type=template&id=00978c35"
import script from "./VueCodemirror.vue?vue&type=script&lang=js"
export * from "./VueCodemirror.vue?vue&type=script&lang=js"
import style0 from "./VueCodemirror.vue?vue&type=style&index=0&id=00978c35&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00978c35')) {
      api.createRecord('00978c35', component.options)
    } else {
      api.reload('00978c35', component.options)
    }
    module.hot.accept("./VueCodemirror.vue?vue&type=template&id=00978c35", function () {
      api.rerender('00978c35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueCodemirror/VueCodemirror.vue"
export default component.exports